import React, { useMemo } from 'react';
import { DefaultTFuncReturn } from 'i18next';
import { FormikProps } from 'formik';
import { clsx } from 'clsx';

import Icon from '../icon/icon.component';
import styles from './input.module.scss';

interface IProps extends React.InputHTMLAttributes<HTMLInputElement> {
  name: string;
  formik?: FormikProps<any>;
  label?: DefaultTFuncReturn | string;
}

const Input: React.FC<IProps> = ({ formik, name, label, ...rest }) => {
  const getError: string | null = useMemo(() => {
    if (!formik?.errors) {
      return null;
    }

    return formik?.errors[name] as string;
  }, [formik, name]);

  return (
    <div
      className={clsx({
        [styles.input]: true,
        [styles['input--error']]: !!getError && formik?.touched[name],
        [styles['input--success']]: !getError && formik?.touched[name],
      })}
    >
      <input
        {...rest}
        name={name}
        placeholder=" "
        onBlur={() => formik?.setFieldTouched(name, true, true)}
        onFocus={() => formik?.setFieldTouched(name, false, true)}
      />
      {label ? <label>{label}</label> : null}
      {formik?.touched[name] && !!getError && (
        <span className={styles['input--error__message']} aria-label={getError}>
          <Icon name={'CircleAlert'} size={16} />
        </span>
      )}
    </div>
  );
};

export default Input;
